export type Timer = {
  setTimeout: (onTimeout: (() => void) | null, tickLimit?: number) => void;
  start: () => void;
  stop: () => void;
  isRunning: () => boolean;
  currentCount: () => number;
  remainingTicks: () => number;
};

export function Timer(
  this: Timer,
  tickInterval?: number,
  onTick?: () => void,
): void {
  tickInterval = tickInterval ? tickInterval : 1000;

  var tickLimit = 0;
  var onTimeout = null as (() => void) | null;
  var count = 0;
  var timerID = 0;
  var running = false;

  this.setTimeout = function (_onTimeout, _tickLimit) {
    onTimeout = _onTimeout;
    tickLimit = _tickLimit != null ? _tickLimit : 1;
  };

  this.start = function () {
    this.stop();
    count = 0;
    running = true;
    var t = this;
    timerID = setInterval(function () {
      count += 1;
      if (onTick) onTick();
      if (tickLimit > 0 && t.remainingTicks() <= 0) {
        t.stop();
        if (onTimeout != null) onTimeout();
      }
    }, tickInterval) as unknown as number;
    //setInterval returns a number, but this typelib says otherwise, causing a warning. just override, for now
  };

  this.stop = function () {
    if (timerID) {
      clearInterval(timerID);
      timerID = 0;
    }
    running = false;
  };

  this.isRunning = function () {
    return running;
  };

  this.currentCount = function () {
    return count;
  };

  this.remainingTicks = function () {
    return tickLimit - count;
  };
}
